import { fromNow } from '@helpers/TimeAgoHelper'

window.webpackExports = {
  fromNow,
}
